import { render, staticRenderFns } from "./JcCart.vue?vue&type=template&id=a49b201a&scoped=true&"
import script from "./JcCart.vue?vue&type=script&lang=js&"
export * from "./JcCart.vue?vue&type=script&lang=js&"
import style0 from "./JcCart.vue?vue&type=style&index=0&lang=css&"
import style1 from "./JcCart.vue?vue&type=style&index=1&id=a49b201a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a49b201a",
  null
  
)

export default component.exports